<script>
  import { onMount } from 'svelte';

  import { blurOnClick } from '../../../../js/blurOnClick';
  import { getEnvironmentFromHostname } from '../../../../js/urlUtils';
  import { trackLinkClick } from '../../../../js/trackLinkClick';
  import DeveloperLockup from './DeveloperLockup/DeveloperLockup.svelte';
  import LogoJewel from './LogoJewel/LogoJewel.svelte';
  import LogoLockup from './LogoLockup/LogoLockup.svelte';

  export let id = undefined;
  export let title = 'Square';
  export let subtitle = undefined;
  export let url = '/';

  let homeUrl;

  function getHomeUrl() {
    let env;

    if (window.Sq && window.Sq.Environment) {
      env = window.Sq.Environment.env;
    } else {
      env = getEnvironmentFromHostname(window.location.hostname);
    }

    switch (env) {
      case 'development':
      case 'test': {
        return '/';
      }
      case 'staging': {
        return 'https://squareupstaging.com';
      }
      default: {
        return 'https://squareup.com';
      }
    }
  }

  onMount(() => {
    homeUrl = getHomeUrl();
  });
</script>

<div class="HomeLink">
  {#if subtitle}
    {#if subtitle === 'Developer'}
      <div class="developer-lockup">
        <DeveloperLockup {title} {subtitle} />
        <a {id} href={homeUrl} use:blurOnClick use:trackLinkClick={{ id, title, url: homeUrl }} aria-label="home">
          <div class="logo-lockup-overlay"></div>
        </a>
        <a {id} href={url} use:blurOnClick use:trackLinkClick={{ id, title, url }} aria-label="url">
          <div class="developer-subtitle-overlay"></div>
        </a>
      </div>
    {:else}
      <a {id} href={homeUrl} use:blurOnClick use:trackLinkClick={{ id, title, url: homeUrl }}>
        <LogoJewel {title} />
      </a>
      <div class="spacer-line"></div>
      <a {id} href={url} class="subtitle" use:blurOnClick use:trackLinkClick={{ id, title, url }}>
        {subtitle}
      </a>
    {/if}
  {:else}
    <a {id} href={homeUrl} use:blurOnClick use:trackLinkClick={{ id, title, url }}>
      <LogoLockup {title} />
    </a>
  {/if}
</div>

<style>@charset "UTF-8";
.HomeLink {
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-shrink: 0;
  padding: 10px;
  outline: none;
  border: none;
  border-radius: 4px;
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  line-height: 28px;
  font-weight: var(--font-weight-medium, 500);
  letter-spacing: normal;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
}
.HomeLink::-moz-focus-inner {
  border: 0;
}
.HomeLink:focus {
  outline: none;
}
.HomeLink::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1), transform 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0);
}
.HomeLink:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
.HomeLink > * {
  position: relative;
}

.spacer-line {
  border-right: 1px solid var(--color-text, #1a1a1a);
  height: 22px;
  width: 0;
  margin: 0 calc(18px - 1px) 0 18px;
}

.subtitle {
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 20px;
  line-height: 22px;
  font-weight: var(--font-weight-medium, 500);
  letter-spacing: -0.01em;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  color: var(--color-text, #1a1a1a);
  height: 22px;
}

.logo-lockup-overlay {
  position: absolute;
  left: 0;
  top: 0;
  height: 22px;
  width: 88px;
  z-index: 100;
}

.developer-subtitle-overlay {
  position: absolute;
  left: 88px;
  top: 0;
  height: 22px;
  width: 100px;
  z-index: 100;
}</style>
